import React from 'react';
import { View, Text } from 'react-native';
import i18n from 'i18n-js';
import { connect } from 'react-redux';

import { scale } from '@components/frame';
import { font } from '@styles/fonts';
import Svg from '@styles/icons/svg';
import { getBoxShadowStyle } from '@styles/shadow';
import TouchableElement from '@components/common/touchableElement';
import { unlogin } from '@reducers/utils';
import { navigateBack } from '@helpers';
import Button from '@components/button/index';
import { modalFieldBg } from '@v2/pages/common/constants/base.constants';

const RunningConnector = ({ C, onBoarding, backgroundColor, logOnboarding, unlogin }) => {
  return (
    <View
      style={{
        width: '100%',
        flex: 1,
        alignItems: 'center',
        backgroundColor: backgroundColor || C('Background/Light/System'),
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
      }}
    >
      <View
        style={[
          getBoxShadowStyle({ type: 'Wide', C }),
          {
            width: scale(400),
            backgroundColor: C(modalFieldBg),
            borderRadius: scale(40),
            alignItems: 'center',
          },
        ]}
      >
        <TouchableElement onPress={navigateBack}>
          {({ boxStyle }) => (
            <View
              style={[
                boxStyle,
                {
                  backgroundColor: C('Button/Light/Secondary'),
                  width: scale(20),
                  height: scale(20),
                  borderRadius: scale(20),
                  justifyContent: 'center',
                  alignContent: 'center',
                  alignItems: 'center',
                  position: 'absolute',
                  top: scale(20),
                  right: scale(20),
                },
              ]}
            >
              <Svg icon="times" width={scale(9)} height={scale(9)} color={'Button/Light/Only Text Text'} />
            </View>
          )}
        </TouchableElement>
        <View>
          <Text style={[font['Title 1'], { color: C('Label/Light/Primary'), marginTop: scale(46), width: '100%', textAlign: 'center' }]}>
            {i18n.t('Connected')}
          </Text>
        </View>
        <View
          style={[
            getBoxShadowStyle({ type: 'Narrow', C }),
            {
              marginTop: scale(7),
              height: scale(108),
              width: scale(120),
              borderRadius: scale(12),
              backgroundColor: C('Background / Light / Field'),
              alignItems: 'center',
            },
          ]}
        >
          <View style={{ marginTop: scale(14) }}>
            <Svg icon="smartIcon" width={scale(48)} height={scale(62)} color="Other/Light/Logo/Factory" />
          </View>
          <Text style={[font['Subhead 2'], { color: C('Label/Light/Primary'), marginTop: scale(7), zIndex: 1000 }]}>{i18n.t('Connector')}</Text>
        </View>
        <View>
          <Text style={[font['Body'], { color: C('Label/Light/Quaternary'), marginTop: scale(13), textAlign: 'center' }]}>
            {onBoarding?.registeredConnector?.localIpAddress}
          </Text>
          <Text style={[font['Subhead 2'], { color: C('Label/Light/Quaternary'), marginTop: scale(1), textAlign: 'center' }]}>
            {onBoarding?.registeredConnector?.macAddress}
          </Text>
        </View>
        <View>
          <Text
            style={[
              font['Body'],
              {
                color: C('Label/Light/Primary'),
                marginTop: scale(26),
                textAlign: 'center',
                width: scale(330),
                marginBottom: scale(22),
              },
            ]}
          >
            {i18n.t('A Smart Factory Connector is running on your local network on {{localHost}} for {{tenantCompanyName}}', {
              tenantCompanyName: onBoarding?.registeredConnector?.tenantCompanyName || '',
              localHost: onBoarding?.registeredConnector?.localHost || '',
            })}
          </Text>
          <View style={{ width: '100%', paddingHorizontal: scale(61), marginBottom: scale(27) }}>
            <Button
              {...{
                name: i18n.t(`Login`),
                onPress: async () => {
                  logOnboarding(`Component: Running Connector. Action: Login`, { component: 'Running Connector', action: 'Login' });
                  unlogin();
                },
                height: scale(45),
                width: '100%',
              }}
            />
          </View>
        </View>
      </View>
    </View>
  );
};

export default connect(null, { unlogin })(RunningConnector);
